<template>
  <div>
    <el-table :data="tableData" border>
      <el-table-column
        :label="$t('operationCenter.ind')" type="index" width="80px"
        align="center"
      />

      <el-table-column :label="$t('basicData.Operator')" width="180px" align="center">
        <template slot-scope="scope">
          <div>{{ createUser[scope.row.createUser] }}</div>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('operationCenter.operationTime')" min-width="180px" prop="createTime"
        align="center"
      />
      <el-table-column
        :label="$t('basicData.Classification')" min-width="140px" prop="operateType"
        align="center"
      >
        <template slot-scope="scope">
          <div>{{ scope.row.operateType === 1 ? $t('CenterForSorting.add') : $t('CenterForSorting.modify') }}</div>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('basicData.ActionContent')" min-width="200px" prop="operateType"
        align="left"
      >
        <template slot-scope="scope">
          <div>
            <div v-if="operationType === 2">
              <div>{{ $t('CenterForSorting.StateTwoCode') }}：{{ scope.row.areaData.twoCode }}</div>
            </div>
            <div v-if="operationType === 5">
              <div>{{ $t('CenterForSorting.StateTwoCode') }}：{{ scope.row.areaData.twoCode }}</div>
              <div>{{ $t('orderCenterCont.city') }}：{{ scope.row.areaData.name }}</div>
              <div>{{ $t('basicData.zipCode') }}：{{ scope.row.areaData.zipCode }}</div>
              <div>{{ $t('mdfeTranslate.IBGECode') }}：{{ scope.row.areaData.ibge }}</div>
              <div>ISS：{{ scope.row.areaData.issTaxation ? scope.row.areaData.issTaxation + '%' : '' }}</div>
              <div>{{ $t('placeOrder.area') }}：{{ scope.row.areaData.regionalLevelName ? scope.row.areaData.regionalLevelName : '' }}</div>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        layout="total, sizes, prev, pager, next, jumper"
        :current-page.sync="queryParam.pageNumber"
        :page-sizes="[10, 20, 50, 100]"
        :page-size.sync="queryParam.pageSize"
        :total="total"
        background
        style="margin: 10px 0"
        @current-change="getCurrencyTableData"
        @size-change="getSizeTableData"
      />
    </div>
  </div>
</template>
<script>
import { getUserIdAndNameObj } from '@/enums/storageEnum';
import { areaOperateLogPage } from '@/api/finance/basicData';

export default {
  name: 'OperationLog',
  props: {
    rowData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    operationType: {
      type: Number,
      default: 2
    }
  },
  data() {
    return {
      tableData: [],
      createUser: [],
      queryParam: {
        pageNumber: 1,
        pageSize: 10,
        params: {
          areaId: null
        }
      },
      total: 0
    };
  },
  created() {
    this.createUser = getUserIdAndNameObj();
    // const all
    this.getTableData();
  },
  methods: {
    getTableData() {
      this.queryParam.params.areaId = this.rowData.id;
      areaOperateLogPage(this.queryParam).then(res => {
        if (res.code === 200) {
          this.total = res.data.total;
          if (res.data.records && res.data.records.length > 0) {
            res.data.records.map(item => {
              item.areaData = JSON.parse(item.areaData);
            });
            this.tableData = res.data.records;
          } else {
            this.tableData = [];
          }
        }
      });
    },
    getCurrencyTableData(val) {
      this.queryParam.pageNumber = val;
      this.getTableData();
    },
    getSizeTableData(val) {
      this.queryParam.pageNumber = 1;
      this.queryParam.pageSize = val;
      this.getTableData();
    }
  }
};
</script>

<style scoped>

</style>
